import { validateUserAgent } from "../../organisms/utils.js";
import styled from "styled-components";

const ModalCustomContainer = styled.div`
  display: ${(props) => (props.isOpen ? "block" : "none")};
  height: 100%;
  position: fixed;
  padding-top: 50% ;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  overflow:scroll;
  z-index: 10000;
`;

export default ModalCustomContainer;